import React from "react"
import MessageQueryWrapper from "./MessageQueryWrapper"

const MessageListCustomer = () => {
  return <MessageQueryWrapper isCustomer={true} />
}

export default MessageListCustomer
